import React from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FILTRO_IGUAL, FILTRO_MAYOR} from "../../framework2/ej2/UI/FormularioGridBusqueda";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {servicioRestfulCompleto, servidor} from "../Configuracion";
import ListaChecks from "../../framework2/ej2/UI/ListaChecks";
import {Button, Intent, Menu, MenuDivider, Spinner} from "@blueprintjs/core";
import MenuLateralItem from "../../framework2/blueprint/MenuLateralItem";
import {
    estadoChangePagina,
    PAGE_FACTURACION_ANALISIS, PAGE_FISCAL_ANALISIS,
    PAGE_LABORAL_CONTRATOS, PAGE_MODELOS,
    PAGE_PRESENTACIONESMODELOS, PAGE_ROLES,
    PAGE_SAGE_DATOS_MODELO_202,
    PAGE_SAGE_DIVIDIR_NOMINAS,
    PAGE_SAGE_DOCUMENTOS,
    PAGE_SAGE_FACTURACION_NOMINAS,
    PAGE_SAGE_MODIFICAR_EMPLEADO_TEXTO,
    PAGE_SAGE_REGISTRO_FACTURAS,
    PAGE_SAGE_REGISTRO_FACTURAS_CULTURA, PAGE_USUARIOS
} from "../redux/estado/actions";


class UsuarioRoles extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            usuario: props.usuario,
            roles: [],
            marcadosIniciales: [],
            marcados: [],
        }
    }

    componentDidMount() {
        this.loadRoles();
    }

    /*
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};
        if(nextProps.usuario !== prevState.usuario){
            newState.usuario= nextProps.usuario;
            newState
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }
    */

    loadRoles= () => {
        this.setState({cargandoDatos: true});
        let condiciones= [{tipo: FILTRO_MAYOR, nombreCampo: "codigo", valor: 0}];
        let filtro= {posInicial: 0, numElementos: 0, condiciones: condiciones, orden: [{nombreCampo:"nombre", asc:true}]};
        let url= servidor + servicioRestfulCompleto + "list/Rol";
        const clienteRestful = new ClienteRestful().setUrl(url);
        console.log("url: ", url);
        clienteRestful.doPost(filtro, response => {
            console.log(response);
            let roles= response
            this.setState({roles: roles, cargandoDatos: false}, () => this.loadUsuarioRoles());
        });
    }

    loadUsuarioRoles= () => {
        const {usuario} = this.props;

        let parametros= {
            usuarioCodigo: usuario.codigo,
        }
        let url= servidor + "completo/restful/servicio/Usuariorol/getRoles";
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost( parametros,response => {
            if (clienteRestful.isExito()) {
                console.log(response);
                this.setState({marcadosIniciales: this.prepararMarcadosIniciales(response)});
            }
        });
    }

    prepararMarcadosIniciales= (marcadosInicialesOriginales) => {
        let marcadosIniciales= [];
        marcadosInicialesOriginales.forEach((item, index) => {
            marcadosIniciales.push(item.codigo);
        });
        return marcadosIniciales;
    }



    guardar= () => {
        const {marcados} = this.state;
        const {auth, usuario, onGuardado} = this.props;

        let parametros= {
            usuarioAuthCodigo: auth.usuarioCodigo,
            usuarioCodigo: usuario.codigo,
            marcados: marcados
        }
        let url= servidor + "completo/restful/servicio/Usuariorol/actualizar";
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost( parametros,response => {
            if (clienteRestful.isExito()) {
                //alert ("Guardado correctamente");
                onGuardado && onGuardado();
            }
        });

    }

    render() {
         const { cargandoDatos, roles, marcadosIniciales} = this.state;
         //console.log("marcadosIniciales: ", marcadosIniciales);
         return (
            <>
                { (cargandoDatos) &&  <Spinner intent={Intent.PRIMARY} size={50} /> }
                <ListaChecks items={roles} campoTexto="nombre" campoId="codigo"
                             marcadosIniciales={marcadosIniciales}
                             onMarcadosChanged={(newMarcados) => this.setState({marcados:newMarcados}) }
                             desplazamintoNivel={50}
                             anchoCheck={700}
                />
                <div className="botonera" tabIndex="-1">
                    <Button icon="saved" className="boton" onClick={this.guardar} text="Guardar" />
                </div>
            </>
        )
    }


}

UsuarioRoles.propTypes = {
    usuario: PropTypes.object,
    onGuardado: PropTypes.func,
}


const mapStateToProps = function(state) {
    return {
        configuracion: state.configuracion,
        auth: state.auth,
    }
}

export default connect(mapStateToProps)(UsuarioRoles);
